var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operation-report-show-footer-edit w-full flex justify-center items-center"},[_c('cancel-button',_vm._b({on:{"click":_vm.onCancel}},'cancel-button',_vm.cancelButtonProps,false)),_c('update-button',_vm._b({on:{"click":_vm.onUpdate}},'update-button',_vm.updateButtonProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }